import React, { useState } from "react";
import { Card, Grid } from "@mui/material";

import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import VuiInput from "components/ui/VuiInput";
import VuiButton from "components/ui/VuiButton";
import VuiAlert from "components/ui/VuiAlert";
import { authService } from "services";

// Services

function ChangePassword() {
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    // Client-side Validation
    if (passwords.newPassword !== passwords.confirmPassword) {
      setStatus({ type: "error", message: "New passwords do not match." });
      return;
    }
    if (passwords.newPassword.length < 6) {
      setStatus({ type: "error", message: "Password must be at least 6 characters." });
      return;
    }

    setLoading(true);
    try {
      await authService.changePassword(passwords.currentPassword, passwords.newPassword);
      setStatus({ type: "success", message: "Password updated successfully!" });
      setPasswords({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (error) {
      const msg = error.response?.data?.message || "Failed to update password.";
      setStatus({ type: "error", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox mb="26px">
        <VuiTypography variant="lg" fontWeight="bold" color="white" textTransform="capitalize">
          Security Settings
        </VuiTypography><p/>
        <VuiTypography variant="button" color="text" fontWeight="regular">
          Change your account password
        </VuiTypography>
      </VuiBox>

      {status.message && (
        <VuiBox mb={2}>
          <VuiAlert color={status.type === "success" ? "success" : "error"}>
            {status.message}
          </VuiAlert>
        </VuiBox>
      )}

      <VuiBox component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <VuiBox mb={1} ml={0.5}>
              <VuiTypography component="label" variant="caption" color="white" fontWeight="bold">
                Current Password
              </VuiTypography>
            </VuiBox>
            <VuiInput
              type="password"
              name="currentPassword"
              placeholder="Current Password"
              value={passwords.currentPassword}
              onChange={handleChange}
              required
              sx={({ borders: { borderWidth, borderColor } }) => ({
                border: `${borderWidth[1]} solid ${borderColor}`,
              })}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <VuiBox mb={1} ml={0.5}>
              <VuiTypography component="label" variant="caption" color="white" fontWeight="bold">
                New Password
              </VuiTypography>
            </VuiBox>
            <VuiInput
              type="password"
              name="newPassword"
              placeholder="New Password"
              value={passwords.newPassword}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <VuiBox mb={1} ml={0.5}>
              <VuiTypography component="label" variant="caption" color="white" fontWeight="bold">
                Confirm New Password
              </VuiTypography>
            </VuiBox>
            <VuiInput
              type="password"
              name="confirmPassword"
              placeholder="Confirm New Password"
              value={passwords.confirmPassword}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <VuiBox mt={1}>
              <VuiButton type="submit" color="info" fullWidth disabled={loading}>
                {loading ? "UPDATING..." : "UPDATE PASSWORD"}
              </VuiButton>
            </VuiBox>
          </Grid>
        </Grid>
      </VuiBox>
    </Card>
  );
}

export default ChangePassword;